module.exports = __webpack_public_path__ + "static/qgis-522a681f4a60b2351c40051cbefebdab.png";